import { Controller } from "@hotwired/stimulus";
import { createRoot } from "react-dom/client";
import { lazy, Suspense } from "react";
import { BrowserRouter } from "../../helpers/tixxt-router";
import { Wrapper as QueryClientProvider } from "../../helpers/queryClient";

const AuditLogFilter = lazy(
  () => import("../../components/administration/audit_logs/AuditLogFilter"),
);

// Connects to data-controller="audit-log--filter"
export default class extends Controller {
  connect() {
    this.root = createRoot(this.element);

    this.renderFilter();
  }

  renderFilter() {
    this.root.render(
      <BrowserRouter>
        <QueryClientProvider>
          <Suspense fallback={null}>
            <AuditLogFilter />
          </Suspense>
        </QueryClientProvider>
      </BrowserRouter>,
    );
  }

  disconnect() {
    if (this.root) {
      this.root.unmount();
    }
  }
}
